<div 
  class="potential-clients-view-card" 
  [class.tiny-view] = "(isTiny$ | async)"
  data-test="potential-clients-view-card"
>
  <img src='/assets/images/potential-clients-view-card-image.svg' alt='complete' />
  <div>
    <div>
      <h3 class="potential-clients-view-card-header">What will potential clients see?</h3>
      <p class="potential-clients-view-card-body">
        Any profile changes you make will immediately appear on your public profile.
        Keep your live profile link open in a separate tab and refresh it to review your updates in real-time.
      </p>
    </div>
    <div>
      <a 
        href="{{ (shareLink$ | async)?.url }}" 
        target="_blank" 
        class="view-live-profile-line"
        data-test="public-profile-link"
      >
        <p class="view-live-profile">View your live profile</p>
        <iris-icon name="external_link" [size]="iconSizes.SM" class="icon" data-test="psl-launch"></iris-icon>
      </a>
    </div>
  </div>
</div>
